'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatRadioField } from '@blocks-react/components/RadioField';
import { CatFieldset } from '@blocks-react/components/Fieldset';
import { useRadioController } from '../../../../hooks/form-controllers';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { getDefaultValue } from '../../utils';
import styles from '../../AssociatedDealer.module.scss';
export const AssociatedDealerOrderType = ({ name, selectedStoreLocation, stock, standard, label, onChange }) => {
    const defaultValue = getDefaultValue([stock, standard]);
    const { setValue, resetField, control } = useFormContext();
    const { getRadioField, radioFieldset } = useRadioController({
        control,
        name
    }, onChange);
    useEffect(() => {
        if (defaultValue) {
            setValue(name, defaultValue.value);
        }
        else {
            resetField(name);
        }
        return () => {
            resetField(name);
        };
    }, [selectedStoreLocation]);
    return (_jsxs(CatFieldset, { required: true, ...radioFieldset, children: [_jsxs("div", { className: "cat-u-theme-typography-label", children: [label, _jsx("span", { className: styles['required-field'], children: ' (required)' })] }), _jsx(CatRadioField, { ...getRadioField('order-type-stock', stock.value), children: stock.label }), _jsx(CatRadioField, { ...getRadioField('order-type-standard', standard.value), children: standard.label })] }));
};
